var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCyberion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 821.81 137.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#fff;}.e{fill:#ffed00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M752.96,8.08c33.51,0,60.77,27.26,60.77,60.77s-27.26,60.77-60.77,60.77h-174.27c-33.51,0-60.77-27.26-60.77-60.77s27.26-60.77,60.77-60.77h174.27m0-8.08h-174.27c-38.03,0-68.85,30.83-68.85,68.85s30.83,68.85,68.85,68.85h174.27c38.03,0,68.85-30.83,68.85-68.85S790.98,0,752.96,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M730.47,23.24h12.44V114.73h-11.27l-61.17-70.46V114.73h-12.31V23.24h10.61l61.7,71.06V23.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M23.81,94.14c-6.82-6.47-10.23-14.74-10.23-24.79s3.47-18.27,10.4-24.89c6.93-6.62,15.64-9.94,26.14-9.94s20.7,3.06,31.42,9.18v-14.1c-11.76-5.03-22.45-7.54-32.07-7.54-13.95,0-25.68,4.55-35.19,13.64C4.75,44.79,0,56.01,0,69.34c0,8.4,2.08,16.2,6.23,23.41,4.15,7.21,9.8,12.88,16.92,16.99,7.12,4.11,15.8,6.17,26.04,6.17,12.59,0,23.7-2.62,33.32-7.87v-14.43c-10.58,6.82-21.42,10.23-32.53,10.23s-19.35-3.23-26.17-9.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "141.2 54.82 116.68 23.24 100.84 23.24 134.69 66.39 134.69 114.86 148.13 114.86 148.13 66.39 181.98 23.24 166.05 23.24 141.2 54.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M242.07,66.39c9.31-3.89,13.97-10.34,13.97-19.35,0-4.68-1.11-8.8-3.34-12.36-2.23-3.56-5.47-6.36-9.71-8.4-4.24-2.03-10.15-3.05-17.71-3.05h-24.01V114.86h31.02c7,0,12.82-1.16,17.48-3.48,4.66-2.32,8.19-5.31,10.59-8.99,2.4-3.67,3.61-7.85,3.61-12.53,0-5.9-1.98-10.97-5.94-15.22-3.96-4.24-9.28-7-15.97-8.26Zm-27.68-31.48h11.28c11.2,0,16.79,4.4,16.79,13.18,0,4.24-1.48,7.7-4.43,10.36-2.95,2.67-7.92,4-14.92,4h-8.72v-27.55Zm33.68,61.39c-1.55,2.36-3.61,4.1-6.17,5.21-2.56,1.12-7.42,1.67-14.59,1.67h-12.92v-29.05h12.26c6.51,0,11.28,.57,14.3,1.7,3.02,1.14,5.34,2.86,6.99,5.18,1.64,2.32,2.46,4.88,2.46,7.67s-.78,5.25-2.33,7.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "300.75 74.59 338.27 74.59 338.27 62.85 300.75 62.85 300.75 34.91 339.58 34.91 339.58 23.24 287.64 23.24 287.64 114.73 340.83 114.73 340.83 103.06 300.75 103.06 300.75 74.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M433.23,49.05c0-19.14-15.27-25.85-33.85-25.85h-29.48V114.86h13.25v-38.7h14.98l22.06,38.7h13.98l-23.26-40.01c12.4-3.07,22.32-11.55,22.32-25.8Zm-50.08-14.22h14.56c14.25,0,22.08,4.54,22.08,14.22,0,10.3-7.82,15.54-22.08,15.54h-14.56v-29.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 465.03,
    y: 23.24,
    width: 13.12,
    height: 91.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 579.48,
    cy: 69.09,
    r: 46.96
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyberion);
export default __webpack_public_path__ + "static/media/cyberion.6d0f4ebbaae3dcf33c6c85ea5c61fc27.svg";
export { ForwardRef as ReactComponent };